meedy.factory('meedy.rightService', ['$q', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function($q, baseService, objectHelper, config) {

	    function RightService() {
	
	        this.getListByUserType = function(userType) {
	            return baseService.post(config.API_URL + '/right/getListByUserType', userType).then(
	                function(successResponse) {
	                    var data = objectHelper.translateArray(successResponse, ModuleVO);
	                    return data;
	                },
	                function(errorResponse) {
	                    return $q.reject(errorResponse);
	                }
	            );
	        };
	
	    }
	
	    return new RightService();
	}
]);
